import { render, staticRenderFns } from "./BasicsCmp.vue?vue&type=template&id=652ac04c&scoped=true"
import script from "./BasicsCmp.vue?vue&type=script&lang=js"
export * from "./BasicsCmp.vue?vue&type=script&lang=js"
import style0 from "./BasicsCmp.vue?vue&type=style&index=0&id=652ac04c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ac04c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652ac04c')) {
      api.createRecord('652ac04c', component.options)
    } else {
      api.reload('652ac04c', component.options)
    }
    module.hot.accept("./BasicsCmp.vue?vue&type=template&id=652ac04c&scoped=true", function () {
      api.rerender('652ac04c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Add/BasicsCmp.vue"
export default component.exports